import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Globals } from './globals';
import { AppConstants } from '@vanguard/config/appConstants';
import { LocationStrategy } from '@angular/common';
import { BackstageServiceComponent } from '@vanguard/shared/services';
import { environment as configs } from 'environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('appCommonModal') private appCommonModal;

  public applicationModal = {
    backdropClickClose: true,
    showCloseBtn: true,
    title: {
      show: true,
      text: ''
    },
    entries: [
      // {
      //     type: 'error',
      //     description: ''
      // }
    ]
  };

  public imageUrl: string = '';
  public template = AppConstants.LOADER_TEMPLATE;
  constructor(
    private config: NgbModalConfig,
    private modalService: NgbModal,
    public globals: Globals,
    private location: LocationStrategy,
    public backstageServiceComponent: BackstageServiceComponent
  ) {
    // check if back or forward button is pressed
    this.location.onPopState(() => {
      // set isBackButtonClicked to true
      this.backstageServiceComponent.setBackClicked(true);
      return false;
    });
  }
  ngOnDestroy(): void {
    window.removeEventListener('focusin', this.onFocusIn);
  }

  private onFocusIn = (event: FocusEvent) => {
    const el = event.target as
      | HTMLInputElement
      | HTMLTextAreaElement;
    if (
      (el instanceof HTMLInputElement &&
        ['text','password','email','tel','number','url','search'].includes(el.type)) ||
      el instanceof HTMLTextAreaElement
    ) {
      setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'center' }), 500);
    }
  };

  ngOnInit() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.addEventListener('focusin', this.onFocusIn);
    }
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || configs.enableCompressedWidth == true) {
      this.imageUrl = configs?.['loadingPageUrl'] && configs?.['loadingPageUrl']?.['mobileView'] ? configs['loadingPageUrl']['mobileView'] : 'assets/images/resume-screen-v2.svg';
    } else {
      this.imageUrl = configs?.['loadingPageUrl'] && configs?.['loadingPageUrl']?.['webView'] ? configs['loadingPageUrl']['webView'] : 'assets/images/resume-screen-v2.svg';
    }
    this.globals.openModal = (entries, titleText?, showCloseBtn?, backdropClickClose?, modalSize?) => {
      // Open modal only if we have atleast one valid entry
      if (entries && Array.isArray(entries) && entries.length > 0) {
        // Assign entries data
        this.applicationModal.entries = entries;

        // Assign modal title if passed, hidden by default
        this.applicationModal.title.show = false;
        if (titleText) {
          this.applicationModal.title.show = true;
          this.applicationModal.title.text = titleText;
        }

        // Hide close button if passed, show by default
        this.applicationModal.showCloseBtn = true;
        if (!showCloseBtn) {
          this.applicationModal.showCloseBtn = false;
        }

        // Disable background click close, enabled by default
        backdropClickClose = true;
        if (!backdropClickClose) {
          this.applicationModal.backdropClickClose = false;
        }

        if (!this.applicationModal.backdropClickClose) {
          this.config.backdrop = 'static';
          this.config.keyboard = false;
        }

        this.modalService.open(this.appCommonModal, { size: modalSize || 'md', centered: true });
      }
    };
  }

  close() {
    this.modalService.dismissAll();
  }

}
